import { useLocation } from 'react-router-dom';

export function useRouteMatch(routePatterns: { route: string }[]) {
  const { pathname } = useLocation();

  const matchRoute = () =>
    routePatterns.find(({ route }) => {
      // Handle wildcard patterns like '/api/token/*'
      if (route.endsWith('/*')) {
        const basePath = route.slice(0, -2); // Remove '/*'
        return pathname === basePath || pathname.startsWith(`${basePath}/`);
      }
      // Handle exact matches
      return pathname === route || pathname.startsWith(`${route}/`);
    }) ?? null;

  return { matchRoute };
}
